import { render, staticRenderFns } from "./WhatsNewEl.vue?vue&type=template&id=6f0fe150&"
import script from "./WhatsNewEl.vue?vue&type=script&lang=ts&"
export * from "./WhatsNewEl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports